import React, { ReactElement } from 'react';
import styles from './chatButton.module.scss';
import CustomIcon from '@/components/ui/CustomIcon';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import TypewriterText from '../aiChat/components/typewriterText/TypewriterText';

type Props = {
  visible: boolean;
  isOpen: boolean;
  icon?: string;
  primaryColor?: string;
  statusMessage?: string | null;
} & React.ComponentPropsWithoutRef<'button'>;

const ChatButton = ({ onClick, visible, isOpen, icon, primaryColor, statusMessage }: Props): ReactElement => {
  const buttonStyle = primaryColor ? { background: primaryColor } : undefined;

  return (
    <>
      {visible &&
        createPortal(
          <div className={styles['button-wrapper']}>
            {statusMessage && !isOpen && (
              <div className={styles['proactive-bubble']}>
                <p className={styles['bubble-text']}>
                  <TypewriterText text={statusMessage} />
                </p>
                <div className={styles.tail} />
              </div>
            )}
            <button
              onClick={onClick}
              className={classNames(styles['chat-button'], styles['floating-button'], {
                [styles.open]: isOpen,
              })}
              style={buttonStyle}
            >
              {isOpen ? (
                <CustomIcon name="doubleDownArrow" width={30} height={30} />
              ) : icon ? (
                <img src={icon} alt="Chat" width={50} height={50} />
              ) : (
                <CustomIcon name="chatClosed" width={25} height={25} />
              )}
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

export default ChatButton;
